import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import Aqp from "../../libs/mk-react-aqp";
import createLink from "../../libs/createLink";

import {fetchArticles, resetArticles} from "../../creators/articles";

import Dropdown from '../components/Dropdown';
import Toggle from '../components/Toggle';
import Pagination from '../components/Pagination';
import {LoadingBar, PageLoader} from '../components/Loader';
import {Button} from "../components/Button";
import Title from "../components/Title";
import SubControls from "../components/SubControls";
import Modal from "../components/Modal";
import AdvancedEditorArticle from "../components/advanced-editor/AdvancedEditorArticle";
import ArticleCardSmall from "../components/ArticleCardSmall";
import {Can} from "../../ability-context";
import Helmet from "react-helmet";
import {config} from "../../config";
import {canonical} from "../../libs/helper";
import Advertising from "../components/Advertising/Advertising";


let mapping = {
    'currentYear': 'annee',
    'currentMonth': 'mois',
    'isFriends': 'mes-amis'
};

class Articles extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            limit: 27,
            sort: 1,
            page: 1,
            isCertified: true,
            isFriends: false,
            isFavoris: false,
            // isAmateurs: false,
            period: 0,
            currentYear: "",
            currentMonth: ""
        };

        this.aqp = new Aqp(mapping, {
            blacklist: ['limit', 'page'],
            currentLink: createLink('articles'),
            filterDefault: this.filter
        });
        this.state = {
            filter: {...this.filter, ...this.aqp.query, page: this.props.match.params.page || 1},
            toggleCreateArticle: false
        };
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.handlePeriod = this.handlePeriod.bind(this);

        this.getArticles(this.state.filter);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.location.search !== this.props.location.search && this.props.location.search.length === 0 && prevProps.location.search !== "?"){
            this.getArticles(this.filter);
            this.setState({filter: this.filter});
        }
    }

    componentWillUnmount() {
        this.props.resetArticles();
        this.setState({filter: this.filter});
    }

    getArticles(filter) {
        let query = {...filter};
        this.props.fetchArticles(this.aqp.set(query));
    }

    handleFilter(name, value) {
        let filter = {...this.state.filter, [name]: value, page: 1};
        this.setState({filter});
        this.getArticles(filter);
    }

    handlePeriod(period, currentYear, currentMonth) {
        let filter = {...this.state.filter, page: 1};
        if (period === 3) {
            currentYear = filter.currentYear !== "" ? currentYear : new Date().getFullYear();
            currentMonth = filter.currentMonth !== "" ? currentMonth : new Date().getMonth() + 1;
            filter = {...filter, period, currentYear, currentMonth};

        } else {
            filter = {...filter, sort: period, period, currentYear: "", currentMonth: ""};
        }
        this.setState({filter});
        this.getArticles(filter);
    }

    handleChangePage(page) {
        let filter = {...this.state.filter, page};
        this.setState({filter});
        this.getArticles(filter);
        window.scrollTo(0, 0);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(this.props.articlesInitialized !== nextProps.articlesInitialized){
            return true;
        }
        if(this.props.currentUserInitialized !== nextProps.currentUserInitialized){
            return true;
        }

        if(this.props.articlesLoading !== nextProps.articlesLoading){
            return true;
        }
        if(this.props.match.params !== nextProps.match.params){
            return true;
        }
        if(this.props.articlesTotal !== nextProps.articlesTotal){
            return true;
        }
        return this.state !== nextState;
    }

    render() {
        let totalPage = this.props.articles ? Math.ceil(this.props.articlesTotal / this.state.filter.limit) : 0;
        let url = this.aqp.queryUrl(this.state.filter, mapping);
        let currentPage = parseInt(this.state.filter.page);
        return !this.props.articlesInitialized ? (
            <div id="articles">
                <div className="container">
                    <div className="card big">
                        <PageLoader/>
                    </div>
                </div>
            </div>
        ) : (
            <div id="articles">
                <Helmet>
                    <title>{config.preTitle}Blog Sexe Amateur et d'exhib{config.postTitle} {currentPage >1 ? `( page ${currentPage} )` : ""}</title>
                    <meta name="description" content={"Découvrez les ✎  ❤ blogs amateur de Voissa ✎  ❤ et suivez au quotidien les exhibs et contributions des amatrices. Via les photos, vidéos, récits, les Voissanautes se dévoilent sur leur blog"} />
                    <meta name="keywords" content={"blog sexe, blog voissa, blog de sexe, blog sexe amateur"} />
                    {currentPage === 2 && (<link rel="prev" href={canonical(url.link, url.search, "articles") }/>)}
                    {currentPage >= 3 && (<link rel="prev" href={canonical(`${url.link}/${(currentPage - 1)}`, url.search, "articles")} />)}
                    <link rel="canonical" href={currentPage >1 ? canonical(`${url.link}/${currentPage}`, url.search, "articles") : canonical(url.link, url.search, "articles")} />
                    {currentPage < totalPage && (<link rel="next" href={canonical(`${url.link}/${(currentPage +1)}`, url.search, "articles")} />)}
                </Helmet>
                <div className="container">
                    <Advertising sizeMobile={"300x100"} className={"center"} />
                    <div className="card big">
                        <div className="card-controls">
                            <div className="main-controls-row">
                                <Title heading={"heading-1"} display={"display-2"}>
                                    Les Blogs Amateur et exhib de Sexe des Voissanautes
                                </Title>
                                <div className="filters">
                                    <Can action="moderation" subject={"Friend"} >
                                    <Dropdown align="right" activableComponent={(
                                        <Button size={"small"}
                                                icon={"sliders"}
                                                content={"Afficher"}/>
                                    )}>
                                        <ul className="dropdown-menu">
                                            {/*<li className="menu-item">Les articles amateurs<Toggle*/}
                                            {/*    isToggled={this.state.filter.isAmateurs}*/}
                                            {/*    onToggle={() => this.handleFilter("isAmateurs", !this.state.filter.isAmateurs)}/>*/}
                                            {/*</li>*/}
                                            {/*<li className="menu-item">Les blogs certifiés<Toggle*/}
                                            {/*    isToggled={this.state.filter.isCertified}*/}
                                            {/*    onToggle={() => this.handleFilter("isCertified", !this.state.filter.isCertified)}/>*/}
                                            {/*</li>*/}
                                            {this.props.currentUserInitialized && (
                                                <li className="menu-item">Mes Amis<Toggle
                                                    isToggled={this.state.filter.isFriends}
                                                    onToggle={() => this.handleFilter("isFriends", !this.state.filter.isFriends)}/>
                                                </li>
                                            )}
                                        </ul>
                                    </Dropdown>
                                    </Can>
                                    <Can action={"create"} subject="Article">
                                        <Button size={"small"}
                                                btnStyle={"primary-reverse"}
                                                onClick={()=>this.setState({toggleCreateArticle: true})}
                                                content={"Créer un article"}/>
                                        <Modal toggle={this.state.toggleCreateArticle} handleClose={()=>this.setState({toggleCreateArticle: false})}>
                                            <AdvancedEditorArticle handleClose={()=>this.setState({toggleCreateArticle: false})} />
                                        </Modal>
                                    </Can>
                                </div>
                            </div>
                            <SubControls handlePeriod={this.handlePeriod}
                                         period={this.state.filter.period}
                                         currentYear={this.state.filter.currentYear}
                                         currentMonth={this.state.filter.currentMonth}/>
                        </div>

                        <div className={"column"}>
                            {this.props.articlesLoading && (
                                <LoadingBar />
                            )}
                            {totalPage > 1 && (
                                <Pagination
                                    className={"mt-0 mb-16"}
                                    currentPage={this.state.filter.page}
                                    pagesCount={totalPage}
                                    {...this.aqp.queryUrl(this.state.filter, mapping)}
                                    handleChangePage={this.handleChangePage}
                                />
                            )}
                            <div className="articles-grid">
                                <div className="row-grid">
                                    {this.props.articles && this.props.articles.map((article) =>
                                        <ArticleCardSmall handleUserId={this.handleUserId}
                                                          key={article._id}
                                                          {...article}
                                                          likeType={"articles"}
                                                          userStories={this.props.userStories}/>
                                    )}
                                </div>
                            </div>
                            {this.props.articlesTotal === 0 && (
                                <div className={"no-content"}>Aucun article à afficher</div>
                            )}
                            {totalPage > 1 && (
                                <Pagination
                                    currentPage={this.state.filter.page}
                                    pagesCount={totalPage}
                                    {...this.aqp.queryUrl(this.state.filter, mapping)}
                                    handleChangePage={this.handleChangePage}
                                />
                            )}

                            <div className={"footer-articles"}>
                                <p>Puisque beaucoup de plateformes de blogging n'acceptent pas qu'un utilisateur crée son <strong>blog sexe</strong>, Voissa au contraire accueille ceux et celles qui veulent profiter d'un espace de libre expression (sous réserve de respecter la charte de notre communauté) sur lequel ils peuvent publier tout ce qu'ils souhaitent.</p>

                                <p>Photos de sexe (même trouvée sur le net), vidéos amateur, récit de leurs exploits sexuels ou fantasmes etc. c'est au blogueur de décider ce qu'ils veulent partager.</p>

                                <p>Aujourd'hui Voissa compte plus de <strong>25 000 blogs de sexe amateur</strong> et ils sont 100% gratuits.</p>

                                <Title heading={"heading-2"} display={"display-2"}>Blog de sexe amateur</Title>

                                <p>Plusieurs filtres sont proposés pour vous aider à naviguer et trouver les blogs qui vous plaisent le plus. Vous pouvez bien entendu visionner les blogs de vos amis uniquement, les blog des Voissa créateurs et la liste de vos blogs favoris.</p>
                                <p>Comme pour les photos et les vidéos, les membres de la communauté apprécient particulièrement qu'on commente leurs créations. Non seulement vous leur donnerez envie de poursuivre l'aventure mais vous aurez peut être la chance de nouer un contact et de devenir amis sur le site.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        currentUserInitialized: state.currentUser.initialized,
        articles: state.articles.data,
        articlesLoading: state.articles.loading,
        articlesInitialized: state.articles.initialized,
        articlesTotal: state.articles.total,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchArticles,
    resetArticles,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(Articles);
